export const PATIENT_LABEL = 'Patient';
export const CLIENT_LABEL = 'Client';
export const PATIENT_NAME_LABEL = 'Patient name';
export const CLIENT_NAME_LABEL = 'Client name';
